var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-serif bg-gray-100 min-h-full flex flex-col justify-between"},[_c('Navbar'),_vm._t("default"),_c('PromoMarquee'),_c('TheFooter')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }